/* eslint-disable no-console */
import { encodeKebabCase } from '../../../utils/string-utils';

const fabricCollectionNav = document.querySelector('.fabric-collection-nav');
const fabricCollectionNavItems = document.querySelectorAll('.fabric-collection-nav button');
const fabricCollectionSelect = document.querySelector('#AwningFabric');
const fabricCollectionSelectOptions = document.querySelectorAll('#AwningFabric option');
const hiddenSelector = 'hidden';
const filteredSelector = 'filter-applied';
const navItemCt = fabricCollectionNavItems.length;

const getCollectionNameFromHash = (id) => {
  let name = '';
  [].map.call(fabricCollectionNavItems, (item) => {
    const collectionName = item.getAttribute('aria-label');
    if (encodeKebabCase(collectionName) === id) {
      name = collectionName;
    }
  });
  return name;
};

const updateNavAlignment = (filteredNavCt) => {
  if (filteredNavCt < navItemCt) {
    fabricCollectionNav.classList.add(filteredSelector);
  } else {
    fabricCollectionNav.classList.remove(filteredSelector);
  }
};

const getSelectedCollection = (collectionName) => {
  const id = `panel-${encodeKebabCase(collectionName)}`;
  return document.getElementById(id);
};

const resetSelectedCollectionAndFabric = () => {
  // Reset selected swatch
  const selectedTab = fabricCollectionNav.querySelector('[aria-selected="true"]');
  if (!selectedTab) {
    return;
  }
  selectedTab.setAttribute('aria-selected', 'false');
  const panelId = selectedTab.getAttribute('aria-controls');
  const panel = document.getElementById(panelId);
  panel.setAttribute(hiddenSelector, hiddenSelector);
  const option = panel.querySelector('.swatch-checkbox input:checked');
  if (option) {
    option.checked = false;
  }
};

const updateOasisFabrics = (state, panel) => {
  // For Oasis Manual/Motorized we ARE NOT displaying
  // Sea Shore (4949) or Lake Blue (6969)
  const { modelCode } = state;
  const fabricCodeList = [4949, 6969];
  const hideFabrics = modelCode === 'SO' || modelCode === 'SOM';
  fabricCodeList.forEach((fabricCode) => {
    const ipt = panel.querySelector(`[value="${fabricCode}"]`);
    if (ipt) {
      const col = ipt.closest('.col');
      const btn = col.querySelector('.swatch-details-btn');
      if (hideFabrics) {
        col.classList.add('hidden');
        btn.classList.add('hidden');
      } else {
        col.classList.remove('hidden');
        btn.classList.remove('hidden');
      }
    }
  });
};

const updateSelectedOption = (panel) => {
  // Remove selected state from any other swatches in this panel
  const prevSelectedOptions = panel.querySelectorAll('.selected');
  [].map.call(prevSelectedOptions, (option) => {
    option.classList.remove('selected');
  });
  const selectedSwatch = document.querySelector('.swatch-card input:checked');
  if (selectedSwatch) {
    setTimeout(() => {
      selectedSwatch.parentNode.classList.add('selected');
    }, 100);
  }
};

const updateSelectedCollection = (state) => {
  const { fabricCollection } = state;
  // Remove selected state from previous any previously selected tab
  resetSelectedCollectionAndFabric();
  // Set selected states for new tab/content
  const tabId = `tab-${encodeKebabCase(fabricCollection)}`;
  const panelId = `panel-${encodeKebabCase(fabricCollection)}`;
  const tab = document.getElementById(tabId);
  const panel = document.getElementById(panelId);
  tab.setAttribute('aria-selected', 'true');
  panel.removeAttribute(hiddenSelector);
  // If new collection is selected, default select first fabric
  const option = panel.querySelectorAll('.swatch-checkbox input')[0];
  if (option) {
    // Add selected state
    option.checked = true;
  }
  updateSelectedOption(panel);
  updateOasisFabrics(state, panel);
};

const getSelectedFabricOptions = () => {
  const selectedSwatch = document.querySelector('.swatch-card input:checked');
  if (selectedSwatch) {
    const options = selectedSwatch.getAttribute('data-awning-option-value');
    if (options) {
      return JSON.parse(options);
    }
    return null;
  }
  return null;
};

const updateCollectionsBySeries = (state) => {
  const { price } = state;
  const fabricList = Object.keys(price).map(key => (key));
  [].map.call(fabricCollectionNavItems, (item) => {
    const match = fabricList.find(fabric => `tab-${fabric}` === item.id);
    const tab = item.parentNode;
    const panelId = item.getAttribute('aria-controls');
    const panel = document.getElementById(panelId);
    if (match) {
      tab.classList.remove(hiddenSelector);
    } else {
      // Hide both tab and panel of non-available series...
      tab.classList.add(hiddenSelector);
      panel.setAttribute(hiddenSelector, hiddenSelector);
    }
  });
  let selectedVal = '';
  [].map.call(fabricCollectionSelectOptions, (option) => {
    const match = fabricList.find(fabric => fabric === option.value);
    // Select dropdown option
    if (match) {
      option.classList.remove(hiddenSelector);
      if (selectedVal === '') {
        selectedVal = option.value;
      }
    } else {
      option.classList.add(hiddenSelector);
    }
  });
  // Set selected value in dropdown to first non-hidden value
  // console.log(selectedVal);
  fabricCollectionSelect.value = selectedVal;
  updateNavAlignment(fabricList.length);
};

const initializeFabricDataAttributes = () => {
  // Add options to fabric tabs
  [].map.call(fabricCollectionNavItems, (item) => {
    item.setAttribute('data-awning-option', 'fabricCollection');
    const name = item.getAttribute('aria-label');
    item.setAttribute('data-awning-option-value', `{"fabricCollection":"${name}"}`);
  });
  // Add options to fabric swatches
  const fabricSwatchList = document.querySelectorAll('[data-step="fabric"] .swatch-card');
  [].map.call(fabricSwatchList, (item) => {
    const ipt = item.querySelector('input');
    const label = item.querySelector('.swatch-color-name');
    ipt.setAttribute('data-awning-option', 'fabric');
    ipt.setAttribute('data-awning-option-value', `{"fabric":"${label.textContent}", "fabricCode":"${ipt.value}"}`);
  });
};

export {
  getCollectionNameFromHash,
  getSelectedCollection,
  getSelectedFabricOptions,
  initializeFabricDataAttributes,
  updateCollectionsBySeries,
  updateSelectedCollection,
};
/* eslint-enable no-console */
